import { useRef } from "react";
import { Carousel } from "antd";
import { useState } from "react";

import { CSSTransition, SwitchTransition } from "react-transition-group";
export function OurStrengthPc(props) {
  const [imgindex, setImgindex] = useState(0);
  const ListArr = [
    <TeachingExperience />,
    <FiftyTeaching />,
    <ElevenCourse />,
    <FiveReputation />,
    <RealFeel />,
  ];
  return (
    <div className="ourstrength-box">
      <div className="our-strength-text">
        <div className="our-strength-text-cn">
          <span>我们的优势</span>
        </div>
        <div className="our-strength-text-en">
          <span>OUR </span>
          <span>STRENGTH</span>
        </div>
      </div>
      <div className="strength-list-title">
        <div
          className={
            imgindex === 0 ? "strength-list-box-active" : "strength-list-box"
          }
          onClick={() => {
            setImgindex(0);
          }}
        >
          <div className="cn-strength">
            <span>11项教学心得</span>
          </div>
          <div className="en-strength">
            <span>11 TEACHING EXPERIENCES</span>
          </div>
          <div className="sm-krenz-icon"></div>
        </div>
        <div
          className={
            imgindex === 1 ? "strength-list-box-active" : "strength-list-box"
          }
          onClick={() => {
            setImgindex(1);
          }}
        >
          <div className="cn-strength">
            <span>80人金牌教学</span>
          </div>
          <div className="en-strength">
            <span>80 GOLD MEDAL TEACHING</span>
          </div>
          <div className="sm-krenz-icon"></div>
        </div>
        <div
          className={
            imgindex === 2 ? "strength-list-box-active" : "strength-list-box"
          }
          onClick={() => {
            setImgindex(2);
          }}
        >
          <div className="cn-strength">
            <span>13年课程研磨</span>
          </div>
          <div className="en-strength">
            <span>13 COURSE GRINDING</span>
          </div>
          <div className="sm-krenz-icon"></div>
        </div>
        <div
          className={
            imgindex === 3 ? "strength-list-box-active" : "strength-list-box"
          }
          onClick={() => {
            setImgindex(3);
          }}
        >
          <div className="cn-strength">
            <span>10万学员好口碑</span>
          </div>
          <div className="en-strength">
            <span>GOOD REPUTATION</span>
          </div>
          <div className="sm-krenz-icon"></div>
        </div>
        <div
          className={
            imgindex === 4 ? "strength-list-box-active" : "strength-list-box"
          }
          onClick={() => {
            setImgindex(4);
          }}
        >
          <div className="cn-strength">
            <span>上万篇真实学员心得</span>
          </div>
          <div className="en-strength">
            <span>REAL EXPERIENCE OF STUDENTS</span>
          </div>
          <div className="sm-krenz-icon"></div>
        </div>
      </div>
      <div className="slide-box-strength">
        <SwitchTransition>
          <CSSTransition classNames={"fade"} timeout={300} key={imgindex}>
            {ListArr.filter((i, index) => imgindex === index)[0]}
          </CSSTransition>
        </SwitchTransition>
      </div>
    </div>
  );
}
export function ElevenCourse(props) {
  return (
    <div className="wrrapper">
      <div style={{ position: "relative" }}>
        <div className="flex-text">
          <div className="nav-title">
            <span>13年课程研磨</span>
          </div>
          <div>
            <span className="nav-cn-text">优势</span>
            <span className="nav-en-text">STRENGTHS</span>
          </div>
          <div className="nav-explain-text">
            <div>
              <span>
                8年实体班、5年网络班，通过13年的时间打磨的三门绘画基础课程，
              </span>
            </div>
            <div className="toup-devide">
              <span>
                强大的教学团队与教研组、认真对待每一位学生的反馈、持续累积经验与不断改进，
              </span>
            </div>
            <div className="toup-devide">
              <span>让我们对课程充满自信，经得起时间考验。</span>
            </div>
          </div>
          <div className="end-tag">
            <span>TAKE </span>
            <span>IT </span>
            <span>SERIOUSLY & </span>
            <span>ACCUMULATE </span>
            <span>EXPERIENCE & </span>
            <span>IMPROVE </span>CONTINUOUSLY<span></span>
          </div>
          <div className="to-shadow">
            <div className="end-line"></div>
          </div>
        </div>
        <img
          alt="jiazaiz"
          src="images/11coursegrind_03.jpg"
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
}
export function FiftyTeaching(props) {
  return (
    <div className="wrrapper">
      <div className="flex-text">
        <div className="nav-title">
          <span>80人金牌教学</span>
        </div>
        <div>
          <span className="nav-cn-text">优势</span>
          <span className="nav-en-text">STRENGTHS</span>
        </div>
        <div className="nav-explain-text">
          <div>
            <span>
              整个助教团队都会经过充分且持续的训练，完全掌握课程内容和作业要求。
            </span>
          </div>
          <div className="toup-devide">
            <span>因此，即使我们是一个多元化的教学团队，但是对学生而言，</span>
          </div>
          <div className="toup-devide">
            <span>就好像面对着一位“始终在线的老师”。</span>
          </div>
          <div className="toup-devide">
            <span>
              教育是一份有使命感的事业，我们充分了解大家在绘画学习中的困惑与难处，
            </span>
          </div>
          <div className="toup-devide">
            <span>
              Krenz
              老师、助教团队以及管理团队，我们将从课程内容、作业辅导、教学服务
            </span>
          </div>
          <div className="toup-devide">
            <span>
              多个层面尽最大努力、让大家能够达成自己的目标，并有一段很好的学习体验。
            </span>
          </div>
        </div>
        <div className="end-tag">
          <span>80 </span>
          <span>GOLD </span>
          <span>MEDAL </span>
          <span>TEACHING</span>
        </div>
        <div className="to-shadow">
          <div className="end-line"></div>
        </div>
      </div>
      <img
        alt="jiazaiz"
        src="images/50gold_03.jpg"
        width="100%"
        height="100%"
      />
    </div>
  );
}
export function FiveReputation(props) {
  return (
    <div className="wrrapper">
      <div className="flex-text">
        <div className="nav-title">
          <span>10万学员好口碑</span>
        </div>
        <div>
          <span className="nav-cn-text">优势</span>
          <span className="nav-en-text">STRENGTHS</span>
        </div>
        <div className="nav-explain-text">
          <div>
            <span>最让我们引以为傲的正是多年来积累的课程口碑，</span>
          </div>
          <div className="toup-devide">
            <span>
              你可以在 Krenz
              老师的微博、知乎等各个地方看到学员对课程的学习心得，
            </span>
          </div>
          <div className="toup-devide">
            <span>我们强烈建议您了解一下，相信可以引起共鸣。</span>
          </div>
        </div>
        <div className="end-tag">
          <span>100000 </span>
          <span>STUDENTS </span>
          <span>HAVE A </span>
          <span>GOOD </span>
          <span>REPUTATION </span>
        </div>
        <div className="to-shadow">
          <div className="end-line"></div>
        </div>
      </div>
      <img
        alt="jiazaiz"
        src="images/5millionrepitation_03.jpg"
        width="100%"
        height="100%"
      />
    </div>
  );
}
export function RealFeel(props) {
  return (
    <div className="wrrapper">
      <div className="flex-text">
        <div className="nav-title">
          <span>上万篇真实学员心得</span>
        </div>
        <div>
          <span className="nav-cn-text">优势</span>
          <span className="nav-en-text">STRENGTHS</span>
        </div>
        <div className="nav-explain-text">
          <div>
            <span>前往知乎看看真实学员的学习心得 </span>
            <span>{">>"}</span>
          </div>
          <div className="toup-devide">
            点击链接到知乎：
            <a
              href="https://www.zhihu.com/org/kkmo-fa-xue-yuan"
              rel="noreferrer"
              target="_blank"
            >
              https://www.zhihu.com/org/kkmo-fa-xue-yuan
            </a>
          </div>
        </div>
        <div className="end-tag">
          <span>REAL </span>
          <span></span>
          <span>EXPERIENCE </span>
          <span>OF </span>
          <span>STUDENTS </span>
        </div>
        <div className="to-shadow">
          <div className="end-line"></div>
        </div>
      </div>
      <img
        alt="jiazaiz"
        src="images/50gold_03.jpg"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function TeachingExperience(props) {
  const contentbox = useRef();
  const next = () => {
    contentbox && contentbox.current.next();
  };
  const prev = () => {
    contentbox && contentbox.current.prev();
  };
  return (
    <div className="wrrapper">
      <div className="turn-icon">
        <div
          className="left-arrow-pc"
          onClick={() => {
            prev();
          }}
        ></div>
        <div
          className="right-arrow-pc"
          onClick={() => {
            next();
          }}
        ></div>
      </div>
      <Carousel ref={contentbox} dots={false} className="strength-slide-box">
        <div>
          <div className="strength-content">
            <div className="strength-div1">
              <div className="experience01-title">
                <span>避免抽象</span>
                <span>容易听懂</span>
              </div>
              <div className="experience02-title">
                <span>量化数据</span>
                <span>新手友好</span>
              </div>
            </div>
            <div className="strength-div2">
              <div className="experience01-en-smtitle">
                <span>EXPERIENCE</span>
                <span>ONE</span>
              </div>
              <div className="experience02-en-smtitle">
                <span>EXPERIENCE</span>
                <span>TWO</span>
              </div>
            </div>
            <div className="strength-div3">
              <div className="experience-cn-text">
                <span>
                  我刚开始学电绘时，经常被各种名词搞得晕头转向，当年从第一次听到「调子」这名词到真正明白「调子」大概的定义，足足花了半年时间的状况。
                </span>
                <div>
                  当我成为老师后，为了避免这种情况，我会
                  <span className="tobold">
                    尽量减少用很抽象的词汇，若有必要也会先帮同学明白其含义
                  </span>
                  ，在说明新的理论和方法时，也尽力使用最清晰的示例帮助大家理解。
                </div>
                <div className="toup">
                  <span>总之，做到让大家一听就懂。</span>
                </div>
              </div>
              <div className="experience-cn2-text">
                <span>
                  在让大家学习新的内容时，我会尽量向学生提供
                  <span className="tobold">
                    可量化的数据、参考标准及操作方法。减少在刚开始缺乏经验时，纯「靠感觉」的状况。
                  </span>
                </span>
                <div className="toup">
                  <span>
                    例如，当提到黑白灰在画面中占有的比例时，我会偏向先给一些基本的比例，比如
                    3:7，1:3:6
                    之类的数字给同学参考（但不会要求完全照搬生硬操作），
                    <span className="tobold">
                      等到同学熟悉一种方式，建立信心，具备一定的经验后，再去自行调整和探索，
                    </span>
                    学习的体验和效果会好很多。
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/our_strength_ph_bg_02_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div>
          <div className="strength-content">
            <div className="strength-div1">
              <div className="experience03-title">
                <span>其实我是一个脱口秀演员</span>
              </div>
              <div className="experience04-title">
                <span>学的好不好</span>
                <span>作业占七成</span>
              </div>
            </div>
            <div className="strength-div2">
              <div className="experience03-en-smtitle">
                <span>EXPERIENCE</span>
                <span>THREE</span>
              </div>
              <div className="experience04-en-smtitle">
                <span>EXPERIENCE</span>
                <span>FOUR</span>
              </div>
            </div>
            <div className="strength-div3">
              <div className="experience-cn03-text">
                <div>
                  <span>
                    我早年在实体班期间，200位学生在教室中需要听上下午各4小时的课程，为了抓住学生的注意力，
                    <span className="tobold">
                      除了保持课程充分的信息量之外，需要尽力活跃课堂气氛，将课程讲的有趣
                    </span>
                    ，并插入一些“互动”与“段子”。实际上除了不断优化课程内容之外，对于课程中讲的出彩有趣的地方我会保留，而如果讲的“段子”不够有趣，我还会把它换掉。
                  </span>
                </div>
              </div>
              <div className="experience-cn04-text">
                <div>
                  作业的设计，是非常讲究技巧和经验的，在我们看来，
                  <span className="tobold">
                    作业是否布置的有水平，就会影响学生最终的学习成果
                  </span>
                  。
                </div>
                <div className="toup">
                  我和助教团队，基于与学生大量的互动与反馈，经过不断改进与优化，开发了一套高效的作业体系，
                  <span className="tobold">
                    课程的每份作业，能做到对指定的知识点和目标进行充分训练
                  </span>
                  。
                </div>
                <div className="toup">
                  举个例子，以头像作业来说，为了让同学能够掌握皮肤透光感与微妙冷暖的混色，作业限制了构图角度、光源方向、人物服装固有色，甚至明暗和色彩都希望能够跟参考图接近。
                </div>
                <div className="toup">
                  总之，
                  <span className="tobold">
                    当作业范围明确时，就很容易看出学生是否有捕捉到知识点，避免靠蛮劲盲练、超纲练习。学生最终也会因为作业做的好，而掌握的更好
                  </span>
                  。
                </div>
              </div>
            </div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/ourstrength_03_04_pc_03_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div>
          <div className="strength-content">
            <div className="strength-div1">
              <div className="experience03-title">
                <span>作业有梯度</span>
              </div>
              <div className="experience06-title">
                <span>激励一步步稳定提升</span>
              </div>
            </div>
            <div className="strength-div2">
              <div className="experience05-en-smtitle">
                <span>EXPERIENCE</span>
                <span>FIVE</span>
              </div>
              <div className="experience06-en-smtitle">
                <span>EXPERIENCE</span>
                <span>SIX</span>
              </div>
            </div>
            <div className="strength-div3">
              <div className="experience-cn03-text">
                <div>
                  <span>
                    <span className="tobold">
                      为了确保良好的学习曲线和课程体验，我们将作业区分了不同的难度
                    </span>
                    ，让同学可以依据自己的程度，来决定先从那个部分开始挑战。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    例如，色彩课中头像的作业，标准题可能是画出有透光以及微妙冷暖的肖像，简单版的可能是仅要求先用色块把明暗交界线画对，困难版则可能是更改不同光源或是更复杂的造型。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    这样的好处是，学生不会有跟不上的挫败感，先做完基础作业，助教给你通过之后，再去挑战DLC
                    作业，
                    <span className="tobold">
                      如此循序渐进，才会一步一个脚印的踏实进步
                    </span>
                    。
                  </span>
                </div>
              </div>
              <div className="experience-cn06-text">
                <div>
                  <span>
                    每个人的情况不同，
                    <span className="tobold">
                      对于基础弱的学生不能要求一蹴而就；对于基础好的学生应当给与积极挑战
                    </span>
                    。因此，我们的教学团队，一直被要求要因材施教。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    比如，如果一个学生有10个问题，一次能改进3-4个就很好，在新手阶段应当尽量避免持续的挫败感让绘画学习更有乐趣，
                    <span className="tobold">稳步提升才最重要</span>。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    当然，同学也完全可以在提交作业的时候，要求助教给与 HardCore
                    模式（慎重）。
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/ourstrength_04_05_pc_03_03_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div>
          <div className="strength-content">
            <div className="strength-div1">
              <div className="experience03-title">
                <span>充分与及时的作业反馈</span>
              </div>
              <div className="experience08-title">
                <span>教学团队更要有一致性</span>
              </div>
            </div>
            <div className="strength-div2">
              <div className="experience07-en-smtitle">
                <span>EXPERIENCE</span>
                <span>SEVEN</span>
              </div>
              <div className="experience08-en-smtitle">
                <span>EXPERIENCE</span>
                <span>EIGHT</span>
              </div>
            </div>
            <div className="strength-div3">
              <div className="experience-cn03-text">
                <div>
                  <span>
                    我们会科学的分配班级人数，确保每个班级，
                    <span className="tobold">每日都有助教专职辅导</span>
                    （除公休日），同时作业分为多个阶段，作业的
                    <span className="tobold">
                      每个阶段都需要提交给助教给与反馈
                    </span>
                    。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    通过这样充分且及时的作业反馈，能更好的帮助和激励学生达到学习目标。
                  </span>
                </div>
              </div>
              <div className="experience-cn06-text">
                <div>
                  <span>
                    整个助教团队都会经过充分且持续的培训，完全掌握课程内容和作业要求。新任助教也会有一位经验丰富的资深助教辅导，担负的责任也会有从少到多从简到难的过程。这让
                    <span className="tobold">
                      整个团队知识体系高度一致并确保作业反馈的质量
                    </span>
                    。
                  </span>
                </div>
                <div className="toup">
                  <span>
                    因此，即使
                    <span className="tobold">
                      我们是一个多元化的老师团队，但是对于学生而言，就好像面对一位“始终在线的老师”
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/ourstrength_06_07_pc_03_03_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div>
          <div className="strength-content">
            <div className="strength-div1">
              <div className="experience03-title">
                <span>根据反馈持续迭代课程</span>
              </div>
              <div className="experience08-title">
                <span>创造良好的学习氛围</span>
              </div>
            </div>
            <div className="strength-div2">
              <div className="experience05-en-smtitle">
                <span>EXPERIENCE</span>
                <span>NINE</span>
              </div>
              <div className="experience06-en-smtitle">
                <span>EXPERIENCE</span>
                <span>TEN</span>
              </div>
            </div>
            <div className="strength-div3">
              <div className="experience-cn03-text">
                <div>
                  <span>
                    <span className="tobold">
                      一门成熟的课程，必定需要持续不断的迭代。
                    </span>
                    早年实体班的五年，课程的优化主要是通过我自己的思考和对同学们的观察。
                  </span>
                </div>
                <div className="toup">
                  近些年随着网络班的
                  <span className="tobold">教学团队的人数增加与多元化</span>
                  特别是每一门课程成立了独立的教研组后，这让我能够获取更多更全面的课程反馈，
                  <span className="tobold">
                    让我们有能力，将课程内容及学习体验优化的更好。
                  </span>
                </div>
              </div>
              <div className="experience-cn06-text">
                <div>
                  <span>
                    多年的教学经验，我有一个洞察，
                    <span className="tobold">
                      如果同学与老师的关系亲密，或者有一个好的学习氛围，往往学生的参与度就会更高，从而获得更好的学习效果
                    </span>
                    。
                  </span>
                </div>
                <div className="toup">
                  因此除了日常作业辅导之外，我自己和助教们都会在“水群”与大家灌水，与学生建立链接（我们也十分享受这个过程），当然我们会鼓励学术性的讨论，礼貌的交流氛围，鼓励和引导那些对社群有帮助的学生和行为。
                </div>
                <div className="toup">
                  让学生爱上这里的学习氛围，享受这个学习过程。
                </div>
              </div>
            </div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/ourstrength_09_10_pc_03_03_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div>
          <div className="experience05-title-box">
            <div>与学生沟通</div>
            <div>达成共识</div>
          </div>
          <div className="experience11-en-smtitle">
            <span>EXPERIENCE</span>
            <span>ONE</span>
          </div>
          <div className="toflex2">
            <div className="experience11-title1">
              <div>
                这一段，其实是对同学们自身要求的期许。因为想要有好的学习效果，我需要大家尽力去做到一些事情，我也会在课程的最开始，就做好这样的沟通——
              </div>
              <div className="toup">
                <span className="tobold">·</span>
                留意作业的目的和要求：每堂课布置的作业都有其练习目的，请根据作业要求的练习点进行，不要超纲作画。
              </div>
              <div className="toup2">
                <span className="tobold">·</span>
                循序渐进：先完成基础作业，助教通过之后，再去挑战进阶作业。
              </div>
              <div className="toup2">
                <span className="tobold">·</span>
                善于观察，取长补短：多观察其他同学的提问和助教的反馈，吸收经验，提升自己。
              </div>
              <div className="toup2">
                <span className="tobold">·</span>
                举一反三：要主动思考助教的反馈，你的作业是否有其他类似的问题，绝不要成为助教的操做工（助教说一步，做一步，最后的进步却很少）。
              </div>
              <div className="toup2">
                <span className="tobold">·</span>
                留意资讯：主动留意群内消息和公告，有时会补充额外的作业解析等重要信息。
              </div>
            </div>
            <div></div>
          </div>
          <img
            alt="jiazaiz"
            src="images/images/ourstrength_11_03_03.jpg"
            width="100%"
            height="100%"
          />
        </div>
      </Carousel>
    </div>
  );
}
